import { GET } from "../../actions/requests/";

export default function request( state = {}, action ) {
    switch( action.type )  {
        case GET.actions.GET_DATA_SUCCESS: return getDataSuccess( state, action );
        case GET.actions.GET_DATA_IS_LOADING: return getDataIsLoading( state, action );
        case GET.actions.GET_DATA_HAS_ERROR: return getDataHasError( state, action );
        default: return state;
    }
}

function getDataSuccess( state, action ) {
    const newState = { ...state };
    const newRequests = { ...state[ action.id ] };
    newRequests.get = { data: action.data.data, isLoading: false };
    newState[ action.id ] = newRequests;
    return newState;
}

function getDataIsLoading( state, action ) {
    const newState = { ...state };
    const newRequests = { ...state[ action.id ] };
    newRequests.get = { data: null, isLoading: action.loading };
    newState[ action.id ] = newRequests;
    return newState;
}

function getDataHasError( state, action ) {
    const newState = { ...state };
    const newRequests = { ...state[ action.id ] };
    newRequests.get = { data: null, isLoading: false, isError: true };
    newState[ action.id ] = newRequests;
    return newState;
}


// WEBPACK FOOTER //
// src/client/reducers/requests/requests.js